import { render, staticRenderFns } from "./Scorenum.vue?vue&type=template&id=6e1218dc"
import script from "./Scorenum.vue?vue&type=script&lang=js"
export * from "./Scorenum.vue?vue&type=script&lang=js"
import style0 from "./Scorenum.vue?vue&type=style&index=0&id=6e1218dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports